const ALL_TOKENS_EXPIRED = 'all-tokens-expired'
const KAKAO_SERVICE_TERM_IDS = [
  'service_20260929',
  'privacy_20260929',
  'pin_20260929',
  'marketing_20260929',
  'third-party_20260929',
  'agree_scrapping_20260929',
]

export {ALL_TOKENS_EXPIRED, KAKAO_SERVICE_TERM_IDS}
